import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { DateFilter, Modal } from '@components';
import AvgDetailModal from '../PriceDetailModal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { addCommas, removeNonNumeric } from '@helper';
import Form from 'react-bootstrap/Form';
import HighGradeModal from '../HighGradeModal';
const CollateralDetail = () => {
    const {
        CollateralDetailStore: {
            collaterals,
            collateralDetails,
            getCollateral,
            startDate,
            endDate,
            updateData,
            reset,
            highGradeCollateralSwitch,
            getLendBusinessTime,
        },
    } = useStore();
    const [show, setShow] = useState(false);
    const [defaultValue, setDefaultValue] = useState('0');
    const [showDetail, setShowDetail] = useState(false);
    const statusBtn = {
        0: {
            text: '成功',
            color: 'btn-warning',
            title: '擔保品已繳付或已退還',
        },
        1: {
            text: '失敗',
            color: 'btn-danger',
            title: '',
        },
        2: {
            text: '失敗',
            color: 'btn-danger',
            title: '',
        },
        3: {
            text: '處理中',
            color: 'btn-processing',
            title: '擔保品繳付或退還作業執行中',
        },
        4: {
            text: '預約中',
            color: 'btn-reserve',
            title: '15:30-09:00申請，為預約單，營業日09:00轉成處理中',
        },
    };
    const [aDetailInfo, setDetailInfo] = useState({});
    let showAvgDetail = false;
    const clickAvgPrice = (data, stockName, stockNo) => {
        if (data.length > 0) {
            data.stockName = stockName;
            data.stockNo = stockNo;
            setDetailInfo(data);
        } else {
            setDetailInfo({});
        }
        // console.log(data.stockNo);
        setShow(true);
        console.log('click', showAvgDetail);
        if (showAvgDetail) {
            showAvgDetail = false;
            setShow(false);
        } else {
            showAvgDetail = true;
            setShow(true);
        }
    };

    useEffect(() => {
        getCollateral(startDate, endDate, defaultValue);
        getLendBusinessTime();
    }, [defaultValue, startDate, endDate]);
    useEffect(() => {
        return () => {
            reset({ startDate: '', endDate: '' });
        };
    }, []);
    return (
        <div>
            <HighGradeModal />
            <AvgDetailModal show={show} setShow={setShow} aInfo={aDetailInfo} />
            <h6 className="title fs-22 fw-bolder mb-3">擔保品明細</h6>
            <div
                className={
                    highGradeCollateralSwitch & !showDetail
                        ? 'tag_quality text-center text-white ms-0 d-inline-block cur-pointer'
                        : 'd-none'
                }
                onClick={() => {
                    updateData('highGradeModalVisible', true);
                }}
            >
                優
            </div>
            <span
                className={
                    highGradeCollateralSwitch & !showDetail
                        ? 'text-black2 align-text-bottom fw-bolder cur-pointer'
                        : 'd-none'
                }
                onClick={() => {
                    updateData('highGradeModalVisible', true);
                }}
            >
                優質擔保品定義
            </span>
            <div className="filter-info d-sm-flex flex-nowrap justify-content-between align-items-center mb-2">
                <Form>
                    <Form.Check
                        inline
                        label="匯總查詢"
                        type="radio"
                        name="radio-search"
                        id="radio-search1"
                        defaultChecked
                        onClick={() => {
                            setShowDetail(false);
                        }}
                    />
                    <Form.Check
                        inline
                        label="明細查詢"
                        type="radio"
                        name="radio-search"
                        id="radio-search2"
                        onClick={() => {
                            setShowDetail(true);
                        }}
                    />
                </Form>
                {showDetail && (
                    <div>
                        <DateFilter
                            defaultValue={defaultValue}
                            data={collateralDetails}
                            setDefaultValue={setDefaultValue}
                            updateData={updateData}
                        />
                    </div>
                )}
            </div>
            <div className="overflow-auto fs-15 scrol_sty">
                {!showDetail ? (
                    <table cellSpacing={0} className="table table_sty fs-6">
                        <thead>
                            <tr>
                                <th
                                    style={{
                                        width: 40 + 'px',
                                    }}
                                ></th>
                                <th>股票代號</th>
                                <th>股票名稱</th>
                                <th>張數</th>
                                <th>均價</th>
                                <th className="pe-sm-5 text-end">
                                    收盤價
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>前一營業日收盤價</Tooltip>
                                        }
                                    >
                                        <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                    </OverlayTrigger>
                                </th>
                                <th className="pe-sm-5 text-end">
                                    市值
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>前一營業日市值</Tooltip>
                                        }
                                    >
                                        <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                    </OverlayTrigger>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {collaterals.map(
                                (
                                    {
                                        stockNo,
                                        stockName,
                                        qty,
                                        closePrice,
                                        marketVal,
                                        averagePrice,
                                        shareList,
                                        hQFlag,
                                    },
                                    index
                                ) => {
                                    return (
                                        !!qty && (
                                            <tr
                                                key={`collateralDetails ${index}`}
                                            >
                                                <th>
                                                    {highGradeCollateralSwitch &
                                                    (hQFlag === 1) ? (
                                                        <div className="tag_quality text-center text-white ms-0 d-inline-block">
                                                            優
                                                        </div>
                                                    ) : (
                                                        <span></span>
                                                    )}
                                                </th>
                                                <th>{stockNo}</th>
                                                <td>{stockName}</td>
                                                <td>{qty}</td>
                                                <td>
                                                    <div
                                                        className="pe-sm-5 text-end cur-pointer"
                                                        onClick={() =>
                                                            clickAvgPrice(
                                                                shareList,
                                                                stockName,
                                                                stockNo
                                                            )
                                                        }
                                                    >
                                                        <span>$</span>
                                                        {averagePrice == null
                                                            ? 0
                                                            : addCommas(
                                                                  averagePrice
                                                              )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="pe-sm-5 text-end">
                                                        <span>$</span>
                                                        {addCommas(closePrice)}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="pe-sm-5 text-end">
                                                        <span>$</span>
                                                        {addCommas(
                                                            removeNonNumeric(
                                                                marketVal
                                                            )
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    );
                                }
                            )}
                        </tbody>
                    </table>
                ) : (
                    <table
                        cellSpacing={0}
                        className="table table_sty fix-last fs-6"
                    >
                        <thead>
                            <tr>
                                <th>繳付日期/退還日期</th>
                                <th>申請書編號</th>
                                {/* <th>申請方式</th> */}
                                <th>申請種類</th>
                                <th>股票代號</th>
                                <th>股票名稱</th>
                                <th className="text-end">張數</th>
                                <th className="fix">狀態</th>
                            </tr>
                        </thead>
                        <tbody>
                            {collateralDetails.map(
                                (
                                    {
                                        applyKind,
                                        applyNo,
                                        applyType,
                                        payDate,
                                        qty,
                                        status,
                                        stockNo,
                                        stockName,
                                        failReason,
                                    },
                                    index
                                ) => {
                                    return (
                                        !!qty && (
                                            <tr
                                                key={`collateralDetailUIs ${index}`}
                                            >
                                                <th>{payDate}</th>
                                                <td>{applyNo}</td>
                                                {/* <td>{applyType}</td> */}
                                                <td>{applyKind}</td>
                                                <td>{stockNo}</td>
                                                <td>{stockName}</td>
                                                <td>
                                                    <div className="text-end">
                                                        {qty}
                                                    </div>
                                                </td>
                                                <td className="fix cur-pointer">
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            failReason ? (
                                                                <Tooltip>
                                                                    {failReason}
                                                                </Tooltip>
                                                            ) : (
                                                                <Tooltip>
                                                                    {
                                                                        statusBtn[
                                                                            status
                                                                        ].title
                                                                    }
                                                                </Tooltip>
                                                            )
                                                        }
                                                    >
                                                        <span
                                                            className={`btn-state btn fs-15 text-white cur-pointer ${statusBtn[status].color}`}
                                                        >
                                                            {
                                                                statusBtn[
                                                                    status
                                                                ].text
                                                            }
                                                        </span>
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>
                                        )
                                    );
                                }
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default observer(CollateralDetail);
